import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=0835dd86"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports